//Global imports
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface previewImage {
    image: string;
    filePath: string;
    width: number;
    height: number;
    fileSizeInKb: number;
}

interface ImageState {
    previewImages: previewImage[];
}

const initialState: ImageState = {
    previewImages: [],
};

const previewImagesSlice = createSlice({
    name: 'previewImages',
    initialState,
    reducers: {
        addPreviewImage: (state, action: PayloadAction<previewImage>) => {
            state.previewImages.unshift(action.payload);
        },
        removePreviewImage: (state, action: PayloadAction<string>) => {
            state.previewImages = state.previewImages.filter(
                (img) => img.image !== action.payload,
            );
        },
        setPositionPreviewImage: (
            state,
            action: PayloadAction<previewImage[]>,
        ) => {
            state.previewImages = action.payload;
        },
        clearPreviewImage: (state) => {
            state.previewImages = [];
        },
    },
});

export const {
    addPreviewImage,
    removePreviewImage,
    clearPreviewImage,
    setPositionPreviewImage,
} = previewImagesSlice.actions;

export default previewImagesSlice.reducer;
